import { Pipeline } from '@ui/__generated__/graphql'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { useNavigationStateStore } from '../navigation/NavigationStateStore'
import { usePipelineModificationStore } from '../pipelinesWorkflow'

interface PipelineState {
  pipelines: Pipeline[]
  selectedPipeline: Pipeline | null
}

interface PipelineActions {
  setPipelines: (pipelines: Pipeline[]) => void
  selectPipeline: (pipeline: Pipeline | null) => void
  setPipelineName: (name: string) => void
  resetStore: () => void
}

const initialState: PipelineState = {
  pipelines: [],
  selectedPipeline: null,
}

export const usePipelinesStore = create<PipelineState & PipelineActions>()(
  persist(
    (set, get) => ({
      ...initialState,

      // Actions
      setPipelines: (pipelines) => set(() => ({ pipelines })),
      selectPipeline: (selectedPipeline) => {
        set(() => ({ selectedPipeline }))
        if (selectedPipeline) {
          useNavigationStateStore.getState().setParams({ pipelineId: selectedPipeline.id.toString() })
          usePipelineModificationStore.getState().setModified(false)
          setTimeout(() => {
            usePipelineModificationStore.getState().takeSnapshot()
          }, 100)
        }
      },
      setPipelineName: (name: string) => {
        const { selectedPipeline } = get()
        if (selectedPipeline) {
          set(() => ({ selectedPipeline: { ...selectedPipeline, name } }))
          usePipelineModificationStore.getState().checkModifications()
        }
      },
      resetStore: () => {
        set(() => initialState)
      },
    }),
    {
      name: 'pipelines',
    }
  )
)
